export const SECTOR_TEMPLATES = {
    RETAIL_CPG: {
        sectorId: 'RETAIL_CPG',
        name: 'Retail & CPG (Sunrise 2027)',
        enabledByDefault: true,
        regulatoryStatus: 'VERIFIED',
        allowedPrimaryAIs: ['01', '8006', '8013'],
        recommendedQualifiers: ['22', '10', '21'],
        requiredLinkTypes: ['gs1:pip'],
        recommendedLinkTypes: [
            'gs1:pip',
            'gs1:instructions',
            'gs1:sustainabilityInfo',
            'myplayer:interactiveVideo',
        ],
        slots: [
            {
                slotId: 'slot_primary_pip',
                friendlyLabel: '1. Primary Brand Experience (Default)',
                linkType: 'gs1:pip',
                isDefaultSlot: true,
                typicalProviderHint: 'Myplayer Project / Brand Site',
                required: true,
            },
            {
                slotId: 'slot_instructions',
                friendlyLabel: '2. User Manual & Care Guide',
                linkType: 'gs1:instructions',
                isDefaultSlot: false,
                typicalProviderHint: 'Myplayer Project / Support Portal',
                required: false,
            },
            {
                slotId: 'slot_sustainability',
                friendlyLabel: '3. Packaging Recycling & Sustainability',
                linkType: 'gs1:sustainabilityInfo',
                isDefaultSlot: false,
                typicalProviderHint: 'Recycling Partner URL',
                required: false,
            },
            {
                slotId: 'slot_interactive_video',
                friendlyLabel: '4. Interactive Video Experience',
                linkType: 'myplayer:interactiveVideo',
                isDefaultSlot: false,
                typicalProviderHint: 'Myplayer Project',
                required: false,
            },
        ],
    },
    FOOD_BEVERAGE: {
        sectorId: 'FOOD_BEVERAGE',
        name: 'Food, Beverage & Grocery',
        enabledByDefault: true,
        regulatoryStatus: 'VERIFIED',
        allowedPrimaryAIs: ['01', '8006'],
        recommendedQualifiers: ['10', '22'],
        requiredLinkTypes: ['gs1:pip', 'gs1:allergenInfo', 'gs1:nutritionalInfo'],
        recommendedLinkTypes: [
            'gs1:pip',
            'gs1:allergenInfo',
            'gs1:nutritionalInfo',
            'gs1:ingredientsInfo',
            'gs1:recallStatus',
            'gs1:traceability',
        ],
        slots: [
            {
                slotId: 'slot_primary_pip',
                friendlyLabel: '1. Primary Brand Experience (Default)',
                linkType: 'gs1:pip',
                isDefaultSlot: true,
                typicalProviderHint: 'Myplayer Project / Brand Site',
                required: true,
            },
            {
                slotId: 'slot_allergens',
                friendlyLabel: '2. Allergens & Ingredients',
                linkType: 'gs1:allergenInfo',
                isDefaultSlot: false,
                typicalProviderHint: 'Food Spec Database / URL',
                required: true,
            },
            {
                slotId: 'slot_nutrition',
                friendlyLabel: '3. Nutritional Facts',
                linkType: 'gs1:nutritionalInfo',
                isDefaultSlot: false,
                typicalProviderHint: 'Food Spec Database / URL',
                required: true,
            },
            {
                slotId: 'slot_ingredients',
                friendlyLabel: '4. Recipes & Ingredients Hub',
                linkType: 'gs1:ingredientsInfo',
                isDefaultSlot: false,
                typicalProviderHint: 'Myplayer Project / Recipe Hub',
                required: false,
            },
            {
                slotId: 'slot_sustainability',
                friendlyLabel: '5. Packaging Recycling Info',
                linkType: 'gs1:sustainabilityInfo',
                isDefaultSlot: false,
                typicalProviderHint: 'Recycling Partner URL',
                required: false,
            },
        ],
    },
    DPP: {
        sectorId: 'DPP',
        name: 'EU Digital Product Passport (ESPR)',
        enabledByDefault: true,
        regulatoryStatus: 'TO_BE_VERIFIED',
        regulatoryNote: 'EU ESPR delegated acts and CEN/CENELEC JTC 24 technical standards are flagged TO_BE_VERIFIED prior to statutory enforcement.',
        allowedPrimaryAIs: ['01', '8013', '8010'],
        recommendedQualifiers: ['10', '21', '8011'],
        requiredLinkTypes: ['gs1:pip', 'gs1:dpp', 'gs1:sustainabilityInfo'],
        recommendedLinkTypes: [
            'gs1:pip',
            'gs1:dpp',
            'gs1:sustainabilityInfo',
            'gs1:certificationInfo',
            'gs1:instructions',
            'gs1:traceability',
        ],
        slots: [
            {
                slotId: 'slot_primary_pip',
                friendlyLabel: '1. Product Story & Lookbook (Default)',
                linkType: 'gs1:pip',
                isDefaultSlot: true,
                typicalProviderHint: 'Myplayer Project / E-comm URL',
                required: true,
            },
            {
                slotId: 'slot_dpp',
                friendlyLabel: '2. EU Digital Product Passport (DPP — TO BE VERIFIED)',
                linkType: 'gs1:dpp',
                isDefaultSlot: false,
                typicalProviderHint: 'External DPP Partner',
                required: true,
            },
            {
                slotId: 'slot_sustainability',
                friendlyLabel: '3. Sustainability & Circularity Data',
                linkType: 'gs1:sustainabilityInfo',
                isDefaultSlot: false,
                typicalProviderHint: 'Sustainability Portal / DPP Provider',
                required: true,
            },
            {
                slotId: 'slot_care_guide',
                friendlyLabel: '4. Care, Repair & Washing Guide',
                linkType: 'gs1:instructions',
                isDefaultSlot: false,
                typicalProviderHint: 'Myplayer Project / Care URL',
                required: false,
            },
        ],
    },
    COUPONS: {
        sectorId: 'COUPONS',
        name: 'Digital Coupons & Promotions (GCN)',
        enabledByDefault: true,
        regulatoryStatus: 'VERIFIED',
        allowedPrimaryAIs: ['255'],
        recommendedQualifiers: [],
        requiredLinkTypes: ['gs1:promotions'],
        recommendedLinkTypes: ['gs1:promotions', 'gs1:pip'],
        slots: [
            {
                slotId: 'slot_promotions',
                friendlyLabel: '1. Coupon Redemption & Offer Terms (Default)',
                linkType: 'gs1:promotions',
                isDefaultSlot: true,
                typicalProviderHint: 'Myplayer Project / Coupon Clearing URL',
                required: true,
            },
            {
                slotId: 'slot_pip',
                friendlyLabel: '2. Eligible Product Information',
                linkType: 'gs1:pip',
                isDefaultSlot: false,
                typicalProviderHint: 'Brand Product Page',
                required: false,
            },
        ],
    },
    LOGISTICS_B2B: {
        sectorId: 'LOGISTICS_B2B',
        name: 'Logistics, Supply Chain & B2B Assets',
        enabledByDefault: true,
        regulatoryStatus: 'VERIFIED',
        allowedPrimaryAIs: [
            '00',
            '401',
            '402',
            '414',
            '415',
            '417',
            '253',
            '8003',
            '8004',
            '8017',
            '8018',
        ],
        recommendedQualifiers: ['254', '7040', '8020', '8019'],
        requiredLinkTypes: ['gs1:logisticsInfo'],
        recommendedLinkTypes: ['gs1:logisticsInfo', 'gs1:traceability', 'gs1:certificationInfo'],
        slots: [
            {
                slotId: 'slot_logistics',
                friendlyLabel: '1. Logistics & Asset Handling Info (Default)',
                linkType: 'gs1:logisticsInfo',
                isDefaultSlot: true,
                typicalProviderHint: 'WMS / Store / Asset Portal',
                required: true,
            },
            {
                slotId: 'slot_traceability',
                friendlyLabel: '2. Chain-of-Custody & Traceability',
                linkType: 'gs1:traceability',
                isDefaultSlot: false,
                typicalProviderHint: 'EPCIS / Traceability Endpoint',
                required: false,
            },
            {
                slotId: 'slot_certification',
                friendlyLabel: '3. Safety & Inspection Certificates',
                linkType: 'gs1:certificationInfo',
                isDefaultSlot: false,
                typicalProviderHint: 'Compliance Document URL',
                required: false,
            },
        ],
    },
    HEALTHCARE_PHARMA: {
        sectorId: 'HEALTHCARE_PHARMA',
        name: 'Healthcare, Pharmaceuticals & Medical Devices',
        enabledByDefault: false,
        regulatoryStatus: 'GXP_COMPLIANCE_GATE_REQUIRED',
        regulatoryNote: 'Disabled by default. Requires GxP / FDA 21 CFR Part 11 / EU Annex 11 validation pack and explicit SUPER_ADMIN activation.',
        allowedPrimaryAIs: ['01', '8013', '8017', '8018'],
        recommendedQualifiers: ['10', '21', '8019'],
        requiredLinkTypes: ['gs1:epil', 'gs1:recallStatus'],
        recommendedLinkTypes: ['gs1:epil', 'gs1:recallStatus', 'gs1:traceability'],
        slots: [
            {
                slotId: 'slot_epil',
                friendlyLabel: '1. Patient Information Leaflet (Default — ePIL Approved Portal Only)',
                linkType: 'gs1:epil',
                isDefaultSlot: true,
                typicalProviderHint: 'ePIL Approved Portal (Myplayer Projects disallowed)',
                required: true,
            },
            {
                slotId: 'slot_recall_status',
                friendlyLabel: '2. Adverse Event / Recall Status',
                linkType: 'gs1:recallStatus',
                isDefaultSlot: false,
                typicalProviderHint: 'Regulatory Recall Endpoint',
                required: true,
            },
            {
                slotId: 'slot_traceability',
                friendlyLabel: '3. Clinical & Supply Chain Traceability',
                linkType: 'gs1:traceability',
                isDefaultSlot: false,
                typicalProviderHint: 'Medical Portal URL',
                required: false,
            },
        ],
    },
};
export const LINK_TYPE_OPTIONS = [
    { value: 'gs1:pip', label: 'gs1:pip — Product Information Page' },
    { value: 'gs1:instructions', label: 'gs1:instructions — Instructions / User Manual' },
    { value: 'gs1:allergenInfo', label: 'gs1:allergenInfo — Allergen Information' },
    { value: 'gs1:nutritionalInfo', label: 'gs1:nutritionalInfo — Nutritional Information' },
    { value: 'gs1:ingredientsInfo', label: 'gs1:ingredientsInfo — Ingredients Information' },
    { value: 'gs1:sustainabilityInfo', label: 'gs1:sustainabilityInfo — Sustainability & Recycling' },
    { value: 'gs1:traceability', label: 'gs1:traceability — Supply Chain Traceability' },
    { value: 'gs1:recallStatus', label: 'gs1:recallStatus — Product Recall & Safety Notice' },
    { value: 'gs1:certificationInfo', label: 'gs1:certificationInfo — Certification & Conformity' },
    { value: 'gs1:dpp', label: 'gs1:dpp — EU Digital Product Passport' },
    { value: 'gs1:epil', label: 'gs1:epil — Patient Information Leaflet (ePIL)' },
    { value: 'gs1:logisticsInfo', label: 'gs1:logisticsInfo — Logistics & Handling' },
    { value: 'gs1:promotions', label: 'gs1:promotions — Promotions & Coupon Redemption' },
    { value: 'myplayer:interactiveVideo', label: 'myplayer:interactiveVideo — Interactive Video' },
    { value: 'myplayer:arExperience', label: 'myplayer:arExperience — AR Experience' },
];
//# sourceMappingURL=sector-templates.js.map